export const SSS_PLACEMENTS = {
    NONE: 'none',
    BELOW_AIBC: '4_spots_below_aibc',
    AIBC_SPOT: 'aibc_spot'
};

// 4th row down from AIBC on mobile (2 cols): 3 rows of 2 products = 6 grid positions
export const SSS_OFFSET_FROM_AIBC = 6;

export const SSS_LINK = '/beauty/skin-analysis-tool';

export const SSS_INTERNAL_CAMPAIGN = 'smart skin scan PLP banner';

export const SSS_PAGE_NAME = 'contentstore:skin-analysis-tool:n/a:*';
